import {
  Coin,
  ShopProductAPI,
  ProductType,
  ShopProduct,
  getActualProducts,
  getProductName,
  getProductSrc,
} from '@whitesharx/starfall-frontend-core';

const COIN_NAME_BY_COUNT: Record<number, string> = {
  1000: 'coins0',
  2200: 'coins1',
  4500: 'coins2',
  10000: 'coins4',
  22000: 'coins5',
  100000: 'coins6',
};

export const formatCoins = (data?: Coin[]) => {
  if (!data) {
    return [];
  }

  return data
    .sort((a, b) => a.count - b.count)
    .filter((coin) => COIN_NAME_BY_COUNT[coin.count])
    .map(({ id, count, price, name, discount }) => ({
      id,
      name,
      src: `assets/images/shop/coins/${COIN_NAME_BY_COUNT[count]}.webp`,
      coins: count,
      price: `${price}$`,
      ...(discount && { discount }),
    }));
};

export const formatProducts = (type: ProductType, data?: ShopProductAPI[]) =>
  getActualProducts(type, data || []).map(({ id }) => {
    const name = getProductName(id);
    return {
      id,
      price: 0,
      src: getProductSrc(type, name),
      name,
      type,
      isBought: false,
      description: '',
    } as ShopProduct;
  });
